export default {
    primary: "#283593", // #E53935
    secondary: "#ffcdd2", // #FFCDD2
    accent: "#3f51b5" // #3F51B5
};
